/* eslint-disable */
import React from 'react';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
// react components for routing our app without refresh
import { Link, withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
// @material-ui/icons
import Settings from '@material-ui/icons/Settings';
import CastForEducation from '@material-ui/icons/CastForEducation';
import Assignment from '@material-ui/icons/Assignment';
import OndemandVideo from '@material-ui/icons/OndemandVideo';
import Menu from '@material-ui/icons/Menu';
import MenuBook from '@material-ui/icons/MenuBook';
import RecordVoiceOver from '@material-ui/icons/RecordVoiceOver';
import MusicVideo from '@material-ui/icons/MusicVideo';
import Cancel from '@material-ui/icons/Cancel';
//import Build from '@material-ui/icons/Build';
// core components
import CustomDropdown from '../../../components/UI/CustomDropdown/CustomDropdown';
import Button from '../../../components/UI/CustomButtons/Button';

import styles from '../../../assets/jss/coscef/components/headerLinksStyle';

const useStyles = makeStyles(styles);

const HeaderLinks = (props) => {
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  const smoothScroll = (e, target) => {
    if (window.location.pathname === '/sections') {
      var isMobile = navigator.userAgent.match(
        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
      );
      if (isMobile) {
        // if we are on mobile device the scroll into view will be managed by the browser
      } else {
        e.preventDefault();
        var targetScroll = document.getElementById(target);
        scrollGo(document.documentElement, targetScroll.offsetTop, 1250);
      }
    }
  };

  const scrollGo = (element, to, duration) => {
    var start = element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;

    var animateScroll = function () {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  };

  const { dropdownHoverColor } = props;

  const classes = useStyles();

  let logoutButton = (
    <ListItem className={classes.listItem}>
      <Button
        link='/logout'
        className={classes.navLink}
        onClick={(e) => {
          e.preventDefault();
          props.history.push('/logout');
        }}
        color='transparent'
      >
        <i className='fa fa-sign-out-alt fa-lg' /> Salir
      </Button>
    </ListItem>
  );

  return (
    <List className={classes.list + ' ' + classes.mlAuto}>
      <ListItem className={classes.listItem}>
        <Button
          link='/servicios'
          className={classes.navLink}
          onClick={(e) => {
            e.preventDefault();
            props.history.push('/servicios');
          }}
          color='transparent'
        >
          <Settings />
          Servicios
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          link='/enseñanzas'
          className={classes.navLink}
          onClick={(e) => {
            e.preventDefault();
            props.history.push('/enseñanzas');
          }}
          color='transparent'
        >
          <CastForEducation />
          Enseñanzas
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          link='/articulos'
          className={classes.navLink}
          onClick={(e) => {
            e.preventDefault();
            props.history.push('/articulos');
          }}
          color='transparent'
        >
          <Assignment />
          Artículos
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          link='/ponencias'
          className={classes.navLink}
          onClick={(e) => {
            e.preventDefault();
            props.history.push('/ponencias');
          }}
          color='transparent'
        >
          <OndemandVideo /> Ponencias
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          navDropdown
          hoverColor={dropdownHoverColor}
          buttonText='Literatura'
          buttonProps={{
            className: classes.navLink,
            color: 'transparent',
          }}
          buttonIcon={Menu}
          dropdownList={[
            <Link
              to='/libros'
              className={classes.dropdownLink}
              onClick={(e) => smoothScroll(e, 'libros')}
            >
              <MenuBook className={classes.dropdownIcons} /> Libros
            </Link>,
            <Link
              to='/cuentos'
              className={classes.dropdownLink}
              onClick={(e) => smoothScroll(e, 'cuentos')}
            >
              <RecordVoiceOver className={classes.dropdownIcons} /> Cuentos
            </Link>,
            <Link
              to='/poesias'
              className={classes.dropdownLink}
              onClick={(e) => smoothScroll(e, 'poesias')}
            >
              <MusicVideo className={classes.dropdownIcons} /> Poesias
            </Link>,
          ]}
        />
      </ListItem>
      {props.isAuth ? logoutButton : null}
    </List>
  );
};

HeaderLinks.defaultProps = {
  hoverColor: 'primary',
};

HeaderLinks.propTypes = {
  dropdownHoverColor: PropTypes.oneOf([
    'dark',
    'dark1',
    'primary',
    'info',
    'success',
    'warning',
    'danger',
    'rose',
  ]),
};

export default withRouter(HeaderLinks);
